export enum ValidationReferenceType {
  form = 0,
  objectModel = 1
}